import React from 'react';

const Stats = ({ statsData }) => {
  const stats = [
    { count: statsData?.active_partners || '150+',    label: 'Active Partners',  color: 'from-sky-500 to-cyan-500' },
    { count: statsData?.events_yearly || '500+',      label: 'Events Yearly',    color: 'from-indigo-500 to-violet-500' },
    { count: statsData?.monthly_visitors || '1.2M+',  label: 'Monthly Visitors', color: 'from-orange-400 to-rose-500' },
    { count: statsData?.satisfaction_rate || '98%',   label: 'Satisfaction',     color: 'from-emerald-400 to-teal-500' },
  ];

  return (
    <section className="relative py-20" data-testid="stats-section">
      <div className="aurora-orb w-[420px] h-[420px] top-0 left-1/4 bg-sky-200/70" />
      <div className="aurora-orb w-[340px] h-[340px] bottom-0 right-1/4 bg-orange-200/60" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="glass-strong rounded-[2rem] p-2">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {stats.map((s, i) => (
              <div
                key={i}
                className="glass rounded-3xl p-6 md:p-8 text-center glass-hover"
                data-testid={`stat-card-${i}`}
              >
                <div className={`text-5xl md:text-6xl font-bold tracking-[-0.04em] bg-gradient-to-r ${s.color} bg-clip-text text-transparent leading-none`}>
                  {s.count}
                </div>
                <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-600 mt-3">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
